export const isString = (value: any): value is string => typeof value === 'string';

export const isFunction = (value: any): value is Function => typeof value === 'function';
